import { useEffect } from 'react';
import { useNavigationGuardStore } from '@/store';

export const usePageNavigationGuard = (guard: (route: string) => void): void => {
  const setNavigationGuard = useNavigationGuardStore((s) => s.setNavigationGuard);
  const clearNavigationGuard = useNavigationGuardStore((s) => s.clearNavigationGuard);

  useEffect(() => {
    setNavigationGuard(guard);
  });

  useEffect(() => () => clearNavigationGuard(), [clearNavigationGuard]);
};

export default usePageNavigationGuard;
